<template>
  <div
    class="diagram-switch-sec"
    :style="{paddingLeft:`${paddingLeft}px`}"
  >
    <i
      class="icon-chevron-back diagram-switch-sec__switch-btn"
      @click="$_preClick()"
    />
    <p class="diagram-switch-sec__switch-title">
      {{ title }}
    </p>
    <i
      class="icon-chevron-forward diagram-switch-sec__switch-btn"
      @click="$_nextClick()"
    />
  </div>
</template>
<script>
export default {
  name: "DiagramSwitchSec",
  props: {
    paddingLeft: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    $_preClick() {
      this.$emit("pre-click", "pre-click");
    },
    $_nextClick() {
      this.$emit("next-click", "next-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-switch-sec";
</style>